{{ message | translate }}
<div class="arrow" [ngClass]="side" #arrow></div>
